export * from './resource-detail.component';
export * from './resource-facet.component';
export * from './resource.service';
export * from './resource-vocab.service';
